import React from 'react';
const IconRatingThumbsDown = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M6 3H15C16.1 3 17 3.9 17 5V15C17 15.55 16.78 16.05 16.41 16.41L9.83 23L8.77 21.95C8.5 21.68 8.33 21.3 8.33 20.89L8.36 20.57L9.31 16H3C1.9 16 1 15.1 1 14V12C1 11.74 1.05 11.5 1.14 11.27L4.16 4.22C4.46 3.5 5.17 3 6 3ZM23 3H19V15H23V3Z" fill="#666666"/>
</svg>
);
};
export default IconRatingThumbsDown;